export const color = {
	CmsPrimary: '#006B35',
	ColorBrandBlue: '#1E9037',
	BackgroundBrandHover: '#F5FAFF',
	BackgroundError: '#FE2E11',
	BackgroundDisable: '#E0DDDD',
	BackgroundBrandSecondary: '#F5FAFF',
	BackgroundSuccessSecondary: '#006B35',
	TextPrimary: '#212121',
	Orange: '#E55A0F',
	Green: '#006B35',
	Blue: '#2381FF',
	Black: 'black',
	BlueV2: '#00579B',
}

export const size = {
	no: 50,
	zero: 0,
	text: 200,
	mediumS: 250,
	medium: 350,
	long: 500,
}
export const textDecoration = {
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap' as 'nowrap',
}
export const userDataFields = [
	{ value: 'name', label: 'Name' },
	{ value: 'phone', label: 'Phone' },
	{ value: 'email', label: 'Email' },
	{ value: 'gender', label: 'Gender' },
	{ value: 'birthday', label: 'Birthday' },
	{ value: 'version', label: 'Version' },
	{ value: 'wallet', label: 'Wallet' },
	{ value: 'invite_code', label: 'Invite code' },
	{ value: 'created_at', label: 'Created at' },
	{ value: 'updated_at', label: 'Updated at' },
	{ value: 'last_login_at', label: 'Last login at' },
	{ value: 'is_verified', label: 'Is verify UniVini' },
	{ value: 'about_me', label: 'About me', width: 100 },
	{ value: 'address', label: 'GPS', width: 100 },
	{ value: 'latitude', label: 'Latitude' },
	{ value: 'longitude', label: 'Longitude' },
	{ value: 'address_local', label: 'Address Local', width: 100 },
	{ value: 'latitude_local', label: 'Latitude Local' },
	{ value: 'longitude_local', label: 'Longitude Local' },
	{ value: 'blocked_at', label: 'Blocked at' },
	{ value: 'blocked_reason', label: 'Blocked reason' },
	{ value: 'blocked_type', label: 'Blocked tyoe' },
	// { value: 'blocked_by', label: 'Blocked by' },
	{ value: 'amount_of_appeal', label: 'Amount of appeal' },

]
export const dateFields = [
	'updated_at',
	'created_at',
	'last_login_at',
	'birthday',
	'blocked_at',
]

export const booleanFields = [
	'is_verified',
]
export const timestampFields = ['birthday']
export const formatDateShort = 'DD/MM'
export const formatDateShortNew = 'dd/MM'
export const formatDate = 'DD/MM/YYYY'
export const formatDateTime = 'DD/MM/YYYY HH:mm:ss'
export const formatDateTimeMinus = 'DD/MM/YYYY HH:mm'
export const passwordRules =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/
export const boxShadow = {
	primary: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
}
export const pathUrl = {
	home: '/',
	configphone: '/configphone',
	topics: '/topics',
	otpTracking: '/otptracking',
	notification: '/notification',
	supportInbox: '/support-inbox',
	changelog: '/changelog',
	service: '/service',
	conversation: '/conversation',
	province: '/province',
	country: '/country',
	network: '/network',
	event: '/event',
	book: '/book',
	bookUniVini: '/book-univini',
	sticker: '/sticker',
	banner: '/banner',
	cacheConfig: '/cache-config',
	googleApiStats: '/google-api-stats',
	myProfile: '/my-profile',
	versionStats: '/version-stats',
	communityStats: '/community-stats',
	block: '/block',
	report: '/report',
	badword: '/badword',
	scriptRun: '/script-run',
	databaseStorage: '/database-storage',
	listYourBiz: '/list-your-biz',
	findMyGuide: '/find-my-guide',
	findMyTutor: '/find-my-tutor',
	courseAi: '/course-ai',
	activeUsers: '/active-users',
	redeemRequests: '/redeem-requests',
}

export const roleCatalogOptions = [
	{ label: 'Dashboard', value: 'HOME:DASHBOARD' },
	{ label: 'User', value: 'ACCOUNT' },
	{ label: 'Events', value: 'EVENTS' },
	{ label: 'Communities', value: 'COMMUNITIES' },
	{ label: 'Topic discuss', value: 'CATEGORY:TOPIC_DISCUSS' },
	{ label: 'Book', value: 'LIBRARY' },
	{ label: 'Trails Collections', value: 'CATEGORY:TRAILS' },
	{ label: 'Notification', value: 'NOTIFICATION' },
	{ label: 'Settings', value: 'SETTINGS' },
	{ label: 'Report', value: 'REPORT' },
	{ label: 'Badword', value: 'BAD_WORD' },
	{ label: 'OTP', value: 'OTP' },
	{ label: 'OTP:Config OTP', value: 'OTP:CONFIG_OTP' },
	{ label: 'OTP:Report OTP', value: 'OTP:REPORT_OTP' },

	// hidden: permissions not in current menu
	// { label: 'Home', value: 'HOME' },
	// { label: 'Home:User by Province', value: 'HOME:USER_OF_PROVINCE' },
	// { label: 'Home:User by Country', value: 'HOME:USER_OF_COUNTRY' },
	// { label: 'Account:Guider', value: 'ACCOUNT:GUIDER' },
	// { label: 'Account:User', value: 'ACCOUNT:USER' },
	// { label: 'Account:Employee', value: 'ACCOUNT:EMPLOYEE' },
	// { label: 'Category', value: 'CATEGORY' },
	// { label: 'Category:Networks', value: 'CATEGORY:NETWORKS_NAME' },
	// { label: 'Changelog', value: 'CHANGELOG' },
	// { label: 'Services', value: 'SERVICES' },
]
// convert value to label
export const convertPermissionValueToLabel = (value: string) => {
	return roleCatalogOptions.find((item) => item.value === value)?.label
}

// Feature Usage Tracking Types
export enum FEATURE_TYPE {
	CONVERSATION_CHAT_ROOM = 'conversation:CHAT_ROOM',
	CONVERSATION_CHAT_LOCATION = 'conversation:CHAT_LOCATION',
	CONVERSATION_PERSONAL = 'conversation:PERSONAL',
	CONVERSATION_CLUB = 'conversation:CLUB',
	POST_EVENT = 'post:EVENT',
	POST_HANGOUT = 'post:HANGOUT',
	DISCUSS_DEFAULT = 'discuss:default',
	SEARCH_LOCAL = 'search-in-app:local',
	SEARCH_EVENT = 'search-in-app:event',
	SEARCH_CLUB = 'search-in-app:club',
	HANGOUT_NOW = 'hangout:now',
	MINI_APP_LIBRARY = 'mini-app:LIBRARY',
	MINI_APP_TUTOR = 'mini-app:TUTOR',
	MINI_APP_TRAIL = 'mini-app:TRAIL',
	MINI_APP_DATING = 'mini-app:DATING',
	MINI_APP_LMB = 'mini-app:LMB',
	MINI_APP_FMG = 'mini-app:FMG',
	MINI_APP_TALKROOM = 'mini-app:TALKROOM',
	MINI_APP_COURSE_AI = 'mini-app:COURSE_AI',
	MINI_APP_COURSE_AI_PROD = 'mini-app:COURSE_AI_PROD',
}

export const FEATURE_TITLE_MAP: Record<FEATURE_TYPE, string> = {
  [FEATURE_TYPE.CONVERSATION_CHAT_ROOM]: 'Chat Room',
  [FEATURE_TYPE.CONVERSATION_CHAT_LOCATION]: 'Chat Location',
  [FEATURE_TYPE.CONVERSATION_PERSONAL]: 'Chat Personal',
  [FEATURE_TYPE.CONVERSATION_CLUB]: 'Communites',
  [FEATURE_TYPE.POST_EVENT]: 'Events',
  [FEATURE_TYPE.POST_HANGOUT]: 'Hangouts',
  [FEATURE_TYPE.DISCUSS_DEFAULT]: 'Discustions',
  [FEATURE_TYPE.SEARCH_LOCAL]: 'Search Local',
  [FEATURE_TYPE.SEARCH_EVENT]: 'Search Event',
  [FEATURE_TYPE.SEARCH_CLUB]: 'Search Club',
  [FEATURE_TYPE.HANGOUT_NOW]: 'Hangout',
  [FEATURE_TYPE.MINI_APP_LIBRARY]: 'Book & Audio',
  [FEATURE_TYPE.MINI_APP_TUTOR]: 'Find my tutors',
  [FEATURE_TYPE.MINI_APP_TRAIL]: 'My trails',
  [FEATURE_TYPE.MINI_APP_DATING]: 'Dating',
  [FEATURE_TYPE.MINI_APP_LMB]: 'List your biz',
  [FEATURE_TYPE.MINI_APP_FMG]: 'Find my guide',
  [FEATURE_TYPE.MINI_APP_TALKROOM]: 'Talk room',
  [FEATURE_TYPE.MINI_APP_COURSE_AI]: 'UniVini Course',
  [FEATURE_TYPE.MINI_APP_COURSE_AI_PROD]: 'UniVini Course',
};

export function featureTypeToTitle(feature: string): string {
	if (!feature) return '';
	if (FEATURE_TITLE_MAP[feature] !== undefined)  return FEATURE_TITLE_MAP[feature];
	return feature.replace('mini-app:', ' ').replace(':now', ' ')
		// tách theo : và -
		.split(/[:-]/)
		.map(part =>
		part
			.toLowerCase()
			.replace(/_/g, ' ')
			.replace(/\b\w/g, char => char.toUpperCase())
		)
		.join(' ');
}
